import { Box, Card, CardMedia, Stack } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";

const About = () => {
  return (
    <Container>
      <Stack sx={{}}>
        <Box sx={{ height: "50%", position: "relative" }}>
          <CardMedia
            component="img"
            height="100%"
            image={`https://ghorami.com/image/banner/help_banner.png`}
            alt="green iguana"
          />
          <Box
            className="box"
            sx={{ position: "absolute", top: "5px", right: "5px" }}
          ></Box>
        </Box>
      </Stack>

      <h4
        class="heading-title"
        style={{
          color: "#222",
          fontWeight: 500,
          textAlign: "center",
          padding: 0,
          fontSize: "1.75em",
          marginBottom: "1em",
        }}
      >
        About Ghorami
      </h4>
      <p>
        Songjukti began over two years ago by pioneering a better way of
        working, helping businesses find more flexibility and connecting talent
        with more opportunities.
      </p>
      <p>
        Our mission to create economic opportunities so people have better lives
        has taken us so much further. As a result, we’ve become the Local’s work
        marketplace where every day businesses of all sizes and independent
        talent from around the Bangladesh meet here to accomplish incredible
        things. Like for so many, Songjukti has had a big impact on my life. I
        first start this company as a IT solution provider and over the years
        have understood what makes this platform really work: the relationships.
      </p>
      <h4>We see what you do</h4>
      <p>
        I have personally seen the passion and commitment that every user puts
        into their work here. Whether it’s a quick powerpoint presentation or a
        multi-year development project - both expert on Songjukti and our
        clients care about doing really good work because they love what they
        do.
      </p>
      <p>
        In fact, we designed it that way. Our work marketplace aligns the goals
        of our clients with the goals of expert on Songjukti so that outcomes
        are better and everyone grows in the same direction. You’ll find tools
        to develop your skills, evolve your business, and gain the control and
        freedom you need for success.
      </p>
      <h4>Songjukti is your workforce</h4>
      <p>
        If you’re a client that’s come here to get things done, use this
        workforce of independent talent to build faster and transform your
        business. If you’re independent talent that’s come here to realize your
        potential, know that you are a valuable and instrumental part of
        someone’s team.
      </p>
      <h4>We make work more rewarding</h4>
      <p>
        We see your vision, and everything we do is an effort to help you make
        the connections that will turn that vision into reality, by building
        your Virtual Talent Bench of trusted people.
      </p>
      <p>
        The impact is both economic and personal, in the everyday and in the
        long run. When you find the right people, you stop working to get by and
        start working strategically.
      </p>
      <p>That is when real opportunity emerges.</p>
      <p>
        I can say with confidence that the Songjukti team - the team that serves
        you the talent and you the client - is still driven by our mission to
        create economic opportunity for our people around the world.
      </p>
      <p>You’re our people now, and we’re glad that you’re here.</p>
      <p>We can’t wait to see what you do.</p>
    </Container>
  );
};

export default About;
